<template>
  <TableGroup
    table-title="Заявки"
    modal-title="Создать заявку"
    namespaced="pto/project/pto/supplyRequest"
    :rights-all="$store.getters.rightsPtoAll"
    :init-filter="initFilter"
    :add-to-post-data="initFilter"
  >
    <template v-slot:modalForm="props">
      <FormPtoProjectPtoSupplyRequest
        :is-sending="props.isSendingRequest"
        @request="props.createSubmit"
        @cancel="props.closeModal"
      />
    </template>
  </TableGroup>
</template>

<script>
import FormPtoProjectPtoSupplyRequest from '@/components/pto/form/FormPtoProjectPtoSupplyRequest'
import TableGroup from '@/components/page/TableGroup'

export default {
  name: 'PtoProjectPtoNomenclature',
  components: {
    FormPtoProjectPtoSupplyRequest,
    TableGroup
  },
  computed: {
    initFilter () {
      return {
        supply_id: this.$route.params.id
      }
    }
  }
}
</script>
